<template>
  <div>
    <div
      v-show="!noResult"
      class="text-left mb-4"
    >
      {{ filteredPresentations.length }} results for <b>"{{ searchText }}"</b>
    </div>
    <div
      class="templates"
      v-show="!isLoadingTemplates"
      v-if="filteredPresentations && filteredPresentations.length > 0"
    >
      <div class="templates-container">
        <TemplateCard
          class="mb-6"
          v-for="presentation in filteredPresentations"
          :key="presentation.id"
          :presentation="presentation"
        />
      </div>

      <div v-if="isLoadmore" class="w-full mb-4 text-center">
        <aha-button
          @click="loadMore()"
          :submitting="isLoadingMore"
          :disabled="isLoadingMore"
        >
          Load more...
        </aha-button>
      </div>
    </div>
    <TemplateSearchNoData
      v-show="!isLoadingTemplates"
      v-if="noResult && isSearching"
      :keyword="searchText"
      @request="clearSearch()"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TemplateCard from './TemplateCard.vue'
import TemplateSearchNoData from '@/components-v2/common/template-library/TemplateSearchNodataMergeSearch.vue'

export default {
  components: {
    TemplateCard,
    TemplateSearchNoData,
  },
  props: {
    filteredPresentations: {
      type: Array,
      default: () => [],
    },
    noResult: {
      type: Boolean,
      default: false,
    },
    isSearching: {
      type: Boolean,
      default: false,
    },
    searchText: {
      type: String,
      default: '',
    },
    isLoadmore: {
      type: Boolean,
      default: false,
    },
    isLoadingMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('presentationTemplates', [
      'isLoadingTemplates',
    ]),
  },
  methods: {
    loadMore() {
      this.$emit('loadMore')
    },
  },
}
</script>
<style scoped lang='scss'>

</style>
